var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUimFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 2H2.99805C2.73283 2 2.47848 2.10536 2.29094 2.29289C2.1034 2.48043 1.99805 2.73478 1.99805 3V21.001C1.99805 21.2662 2.1034 21.5206 2.29094 21.7081C2.47848 21.8956 2.73283 22.001 2.99805 22.001H20.999C21.2643 22.001 21.5186 21.8956 21.7062 21.7081C21.8937 21.5206 21.999 21.2662 21.999 21.001V3C21.999 2.73478 21.8937 2.48043 21.7062 2.29289C21.5186 2.10536 21.2643 2 20.999 2ZM18.894 7.84H17.295C16.042 7.84 15.8 8.436 15.8 9.31V11.236H18.789L18.399 14.255H15.799V22H12.683V14.255H10.076V11.236H12.683V9.01C12.6302 8.48225 12.6934 7.94933 12.8682 7.44859C13.043 6.94784 13.3253 6.4914 13.6951 6.11124C14.065 5.73109 14.5135 5.43644 15.0093 5.24793C15.5051 5.05942 16.036 4.98163 16.565 5.02C17.343 5.01758 18.1205 5.05764 18.894 5.14V7.84Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUimFacebook);
export default __webpack_public_path__ + "static/media/uim_facebook.cd3ad8ab98837821048ad6d46c60f7b0.svg";
export { ForwardRef as ReactComponent };